import * as React from "react";

import { Container } from "../../../Container";
import { addNewRouteFor, editRouteFor, appNavigator } from "../../../routes";
import { PersonGrid } from "./PersonGrid";
import { EntityType, Person } from "../../../../models";
import { EditCreatePersonActions } from "./EditCreatePersonActions";
import { EditCreatePersonStore } from "./EditCreatePersonStore";
import { EditCreateEntityProps, EditCreateEntityRoute } from "../EditCreate/EditCreateEntityRoute";
import { EditCreatePerson } from "./EditCreatePerson";
import { EditCreateEntityActions } from "../../../actions/EditCreateEntityActions";
import { ListStore } from "../../../flux/Grid/ListStore";
import { SelectedItemsActions, SelectedItemsStore } from "../../../flux/Grid";
import { Button } from "../../../../components/Buttons";
import { Toolbar } from "../../Toolbar";
import { UpsertPersonCommand } from "./commands/UpsertPersonCommand";
import { ErrorStore } from "../../../flux/Error/ErrorStore";
import { FlagStore } from "../../../flux/Flag/FlagStore";
import { ErrorActions } from "../../../flux/Error/ErrorActions";
import { twoButtonDialogConfig } from "../../../utils/configure-store";
import { NoResults } from "../../Table/NoResults";
import { TableTitle } from "../../Table/TableTitle";
import { LabelStore } from "../../../flux/Label/LabelStore";
import { SearchProps } from "../SearchProps";
import { GenericSearchWidget } from "../Search/GenericSearchWidget";
import { Polyglot } from "../../../../polyglot";
import { StickyMediator } from "../../../utils/StickyMediator";
import { TrashButtonWidget } from "../../TrashButtonWidget";
import { DeleteItemsProps, DeleteConfirmationWidget } from "../../DeleteConfirmationWidget";
import { Command } from "../../../../Command";

const appStyles = require('../../../app.scss');
const tableStyles = require('../../../../components/Table.scss');

interface TabProps
{
    polyglot: Polyglot;
    isAdmin: boolean;

    tableTitleStore: LabelStore;
    listStore: ListStore<Person>

    selectedItemsStore: SelectedItemsStore<Person>;
    
    editStore: EditCreatePersonStore;
    divisionsLoadInProgress: FlagStore;
    initUpsertCommand: Command;
    upsertInProgressStore: FlagStore;
    upsertErrorStore: ErrorStore;
    upsertCommand: UpsertPersonCommand;
}

type Props = TabProps & SearchProps & DeleteItemsProps;
export class PersonRoute extends React.Component<Props>
{
    private readonly errorActions = new ErrorActions();
    private readonly editActions = new EditCreatePersonActions();
    private readonly editCreateEntityActions = new EditCreateEntityActions();
    private readonly selectedItemsActions = new SelectedItemsActions();

    private readonly stickyMediator = new StickyMediator();

    componentDidMount()
    {
        this.props.refresher.run();
    }
    
    render()
    {
        const { isAdmin, polyglot } = this.props;
        const createForm = ({ title, okTitle, path }) => (
            <Container merge stores={twoButtonDialogConfig(this.props.upsertInProgressStore, this.props.upsertErrorStore)}>
                <EditCreateEntityRoute title={title} okTitle={okTitle} path={path}
                    renderEdit={() => (
                        <Container
                            merge stores={[
                                this.props.editStore,
                                [this.props.divisionsLoadInProgress, (store: FlagStore) => ({ loadingDivisions: store.isSet() })]
                            ]}
                            actions={this.editActions}
                            onMount={this.props.initUpsertCommand.execute}>
                                <EditCreatePerson polyglot={polyglot} loadingDivisions={false} />
                        </Container>
                    )}
                    cancel={() => {}}
                    ok={() => {
                        appNavigator.goToEntityTab(entityType);
                        this.editCreateEntityActions.rejectDraft(entityType);
                    }}
                />
            </Container>
        );

        const entityType = EntityType.Person;
        const disableInject = {
            disabled: () => this.props.selectedItemsStore.getState().selected.size === 0
        };

        return (
            <div>
                { isAdmin && createForm({title: polyglot.t('person.create_title'), okTitle: polyglot.t('button.close'), path: addNewRouteFor(entityType)}) }
                { isAdmin && createForm({title: polyglot.t('person.edit_title'), okTitle: polyglot.t('button.close'), path: editRouteFor(entityType)}) }
                <DeleteConfirmationWidget {...this.props} entityType={entityType} title={polyglot.t('person.del_confirmation_title')}>
                    <span className={appStyles.ConfirmationContainer}>{polyglot.t('person.del_confirmation_msg')}</span>
                </DeleteConfirmationWidget>
                <div>
                    <GenericSearchWidget {...this.props} />
                    <div className={appStyles.StickyControlPanel} ref={this.stickyMediator.onToolbox}>
                        <Toolbar>
                            { isAdmin && <TrashButtonWidget entityType={EntityType.Person} {...this.props} /> }
                        </Toolbar>
                        <TableTitle polyglot={polyglot} labelStore={this.props.tableTitleStore} />
                    </div>
                    <Container merge stores={[this.props.listStore, this.props.selectedItemsStore]}>
                        <PersonGrid
                            className={tableStyles.StickyTable}
                            isAdmin={isAdmin}
                            polyglot={polyglot}
                            selected={null} allSelected={null}
                            onEdit={(datum: Person, row) => {
                                this.editCreateEntityActions.setEntityToEdit(datum, entityType);
                                this.errorActions.clearError(this.props.upsertErrorStore.dispatchToken);
                                appNavigator.goToEditEntityTab(entityType);
                            }}
                            toggle={(datum: Person, row) => this.selectedItemsActions.toggleItem(datum.id, entityType) }
                            toggleAll={() => this.selectedItemsActions.toggleAll(entityType)}
                            onThead={this.stickyMediator.onThead}
                        />
                    </Container>
                    <NoResults polyglot={polyglot} listStore={this.props.listStore} />
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/Person/PersonRoute.tsx